import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExperimentValue, KnownExperiment } from '../../model'

export interface ExperimentsState {
  activeExperiments: Partial<Record<KnownExperiment, ExperimentValue>>
}

export const experimentInitialState: ExperimentsState = {
  activeExperiments: {},
}

const slice = createSlice({
  name: 'experiments',
  initialState: experimentInitialState,
  reducers: {
    triggerExperiment(state: ExperimentsState, action: PayloadAction<[experiment: KnownExperiment, value: ExperimentValue]>) {
      const [experiment, value] = action.payload
      state.activeExperiments[experiment] = value
    },
  },
})

export const { triggerExperiment } = slice.actions

export default slice.reducer
